import React, { useState } from "react";
import "./Header.css";
import { getPublicAssetPath } from "../../utils/getPublicAssets";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
// @ts-ignore
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { RootState } from "../../redux-store/types";

const Header: React.FC = () => {
  const userInfo = useSelector((state: RootState) => state.userInfo);
  const isAuthenticated = userInfo?.authToken ? true : false;
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActiveLink = (linkPath: string, isOverlayNav: boolean) => {
    const normalizePath = (path: string) => path.replace(/\/+$/, "");
    return normalizePath(location.pathname) === normalizePath(linkPath)
      ? isOverlayNav
        ? "overlay-active-link"
        : "active-link"
      : "";
  };

  const logout = () => {
    console.log("logging out...");
    Cookies.remove("enacts_auth_token", { path: "/", domain: "heureka.quest" });
    dispatch({ type: "LOG_OUT" });
    navigate("/signin");
  };

  return (
    <header className="header">
      <div className="nav-container">
        <div className="logo-container">
    
          <img src={getPublicAssetPath("header/EN-logo.png")} alt="logo-1" />
          <img src={getPublicAssetPath("header/HQ-logo.png")} alt="logo-2" />
          <p className="new_title_border">|</p>
           <p className="new_title">Food System Visualization Engine Demonstration</p>
        </div>


 
      </div>
      {/* <div className="nav-links">
      <img src={getPublicAssetPath("header/BIPP_Logo.png")} alt="logo-3" />
        </div> */}
       <div className="profile-container">
       <img className="bipp_logo" src={getPublicAssetPath("header/BIPP_Logo.png")} alt="logo-3" />
      </div>  

    
    </header>
  );
};

export default Header;
